import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import WTDcareLogo from '@/assets/wtdcare-logo.png'
import { formatPhoneNumber } from '@/utils/validation'
import { useLocalization } from '@/contexts/LocalizationContext'

interface LoginHeaderProps {
  step: 'phone' | 'otp'
  phone?: string
}

/**
 * Login page header component with logo and title
 */
export function LoginHeader({ step, phone }: LoginHeaderProps) {
  const { t } = useLocalization()
  
  return (
    <CardHeader className="text-center space-y-4 sm:space-y-6 md:space-y-8 pb-4 sm:pb-6 md:pb-10 pt-6 sm:pt-8 md:pt-10 px-4 sm:px-6">
      {/* Logo */}
      <div className="w-20 h-20 sm:w-28 sm:h-28 md:w-32 md:h-32 mx-auto transition-transform duration-300 hover:scale-105">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-blue-400/10 rounded-2xl blur-xl" />
          <img
            src={WTDcareLogo}
            alt="WTDcare Logo"
            className="relative w-full h-full object-contain drop-shadow-lg"
            role="img"
            aria-label="WTDcare logo"
          />
        </div>
      </div>

      {/* Title and Description */}
      <div className="space-y-2 sm:space-y-3">
        <CardTitle className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 tracking-tight">
          {step === 'phone' ? t('auth.welcomeBack') : t('auth.verifyYourCode')}
        </CardTitle>
        <CardDescription className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed max-w-sm mx-auto">
          {step === 'phone' ? (
            t('auth.enterPhoneNumber')
          ) : (
            <>
              {t('auth.verificationCodeSent')}{' '}
              <span className="font-semibold text-gray-800">{phone ? formatPhoneNumber(phone) : ''}</span>
            </>
          )}
        </CardDescription>
      </div>
    </CardHeader>
  )
}
